import { REQUIRED_FIELD } from "@/lib/constants";
import { FormContext } from "@/providers/form";
import { Radio, RadioGroup, Stack } from "@chakra-ui/react";
import { useContext } from "react";
import { Control, Controller } from "react-hook-form";

export const YesNoRadioGroup = ({
  fieldName,
  control,
  onChangeCallback,
}: {
  fieldName: string;
  control: Control<any>;
  onChangeCallback?: () => void;
}) => {
  const { saveForm } = useContext(FormContext);

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        validate: (val) =>
          val === true || val === false ? true : REQUIRED_FIELD,
      }}
      render={({ field }) => (
        <RadioGroup
          defaultValue=""
          w="100%"
          size="lg"
          value={
            field.value !== undefined && field.value !== null
              ? field.value.toString()
              : undefined
          }
          onChange={(val) => {
            const boolVal = val === "true";
            field.onChange(boolVal);
            saveForm({
              [fieldName]: boolVal,
            });
            if (onChangeCallback) {
              onChangeCallback();
            }
          }}
        >
          <Stack spacing={5} direction="row" display="flex" w="100%">
            <Radio value="true">Yes</Radio>
            <Radio value="false">No</Radio>
          </Stack>
        </RadioGroup>
      )}
    />
  );
};

export default YesNoRadioGroup;
